import { createReducer } from '../utils/reducers';
import {
    GET_SUBSCRIPTIONS_SUCCESS,
    CANCEL_SUBSCRIPTION_SUCCESS,
    CANCEL_SUBSCRIPTION_REQUEST,
    CANCEL_SUBSCRIPTION_FAILURE,
} from '../actions/subscriptions';

import tokenManager from '../utils/token';
import InPlayer from '@inplayer-org/inplayer.js';

const INITIAL_STATE = {
    collection: [],
    total: 0,
    isLoadingButton: false,
};

export default createReducer(INITIAL_STATE, {
    [GET_SUBSCRIPTIONS_SUCCESS]: (state, action) => {
        let newSubscriptions = [];
        if (action.payload.isInitial) {
            newSubscriptions = action.payload.data.collection;
        } else {
            newSubscriptions = state.collection.concat(
                action.payload.data.collection
            );
        }

        return {
            ...state,
            collection: [...newSubscriptions],
            total: action.payload.data.total,
            page: action.payload.page,
        };
    },
    [CANCEL_SUBSCRIPTION_REQUEST]: (state, action) => {
        state.collection.forEach(item => {
            if (item.unsubscribe_url === action.payload.data)
                item.status = 'canceled';
        });

        return {
            ...state,
            collection: [...state.collection],
            isLoadingButton: true,
        };
    },
    [CANCEL_SUBSCRIPTION_SUCCESS]: (state, action) => {
        state.collection.forEach(item => {
            if (item.unsubscribe_url === action.payload.data)
                item.status = 'canceled';
        });

        return {
            ...state,
            collection: [...state.collection],
            isLoadingButton: false,
        };
    },
    [CANCEL_SUBSCRIPTION_FAILURE]: (state, action) => {
        return {
            ...state,
            isLoadingButton: false,
        };
    },
});



// WEBPACK FOOTER //
// ./src/reducers/subscriptions.js